var exports = {
  "D": "x28a7bf27--6616d1--title",
};

module.exports = exports;
